export {
  name,
  answeredCorrectly,
  selfReflection,
  leftSpacer,
  rightSpacer,
} from './TableColumns';
